
import { useEffect, useRef,useState } from 'react';
import { useChatboxStateContext, useChatboxDispatchContext } from '../../context/ChatboxContext';
import { useConversationStateContext } from '../../context/ConversationContext';
const ChatBoxButtonOpen = () => {

    const { valueOpen } = useChatboxStateContext();
    var { chatboxColor, avatar, data ,delay_run_chatbox, notification, ripple_effect} = useConversationStateContext();

    const dispatch = useChatboxDispatchContext();
    const buttonRef = useRef(null); 
    const { messages } = data;
    const changeState = () => {
        dispatch({ type: "openAndClose" })
    };
    const openChatboxWithDelay = (delayInSeconds) => {
        setTimeout(() => {
          dispatch({ type: "openAndClose" }); 
        }, delayInSeconds * 1000); 
    };
    const isImageLink = avatar.match(/\.(png|jpg|jpeg)/i) !== null;
    const [messagesDisplayed, setMessagesDisplayed] = useState(false);
    const [lastNumberOfMessagesDiplayed, setLastNumberOfMessagesDiplayed] = useState(0);
    const textMessagesCount = messages.filter(message => message.type === "text").length - lastNumberOfMessagesDiplayed;

    useEffect(() => {
        if (buttonRef.current) {
            buttonRef.current.style.setProperty('--before-chatbox-border-color', chatboxColor);
            buttonRef.current.style.setProperty('--after-chatbox-border-color', chatboxColor);
        }

        if (valueOpen && !messagesDisplayed && textMessagesCount > 0) {
            setMessagesDisplayed(true);
            setLastNumberOfMessagesDiplayed(textMessagesCount);
        }
    }, [chatboxColor, valueOpen]); 

    useEffect(() => {
        if (delay_run_chatbox && delay_run_chatbox > 0) {
          openChatboxWithDelay(delay_run_chatbox);
        }
    }, [delay_run_chatbox]);
    
    if(!isImageLink) {
        avatar = `data:image/svg+xml;utf8,${encodeURIComponent(avatar)}`;
    }

    return (
        <button ref={buttonRef} className={valueOpen ? "kwalys-close-chatbox-button" : `kwalys-open-chatbox-button ${(!ripple_effect  || valueOpen || messagesDisplayed || textMessagesCount === 0) ? "" : "animate"}`} onClick={changeState} style={{background:chatboxColor}}>
             <img srcSet={avatar}/>
             <div id="kwalys-unread-messages" className={(!notification  ||valueOpen || messagesDisplayed || textMessagesCount === 0) ? "dissapear invisible" : "visible"}>
                {textMessagesCount}
             </div>
        </button>
    );
};

/* <div id="kwalys-unread-messages" className={valueOpen ? "dissapear invisible" : "visible"}>+</div> */
export default ChatBoxButtonOpen;